import { isValutSegregationWalletInstance } from "../../../Services/baasAccountsListApi";

/**
 * Resolve a console instance card from a numeric BaasApiInstanceId (+ optional env lane).
 * Instance card ids are composite `${baasInstanceId}:${environment}` — never Number(card.id).
 *
 * @param {Array<object>} instances
 * @param {number|string|null|undefined} baasInstanceId
 * @param {string|null|undefined} [environment]
 * @returns {object|null}
 */
export const resolveBaasInstanceCard = (
  instances = [],
  baasInstanceId,
  environment = null,
) => {
  const id = Number(baasInstanceId);
  if (!Number.isFinite(id) || id <= 0) return null;
  const matches = (instances || []).filter(
    (row) => Number(row?.baasInstanceId ?? row?.instanceId) === id,
  );
  if (matches.length === 0) return null;
  const env = environment != null && environment !== "" ? String(environment) : null;
  if (env) {
    const envMatch = matches.find((row) => String(row?.environment || "") === env);
    if (envMatch) return envMatch;
  }
  // Prefer production card when multiple lanes share the same baas id shape.
  const prod = matches.find((row) => String(row?.environment || "").toLowerCase() === "production");
  return prod || matches[0];
};

/**
 * True when the account row is a peer Conta Digital (RootAccountId of another tenant)
 * listed under the matrix Contas union.
 */
export const isBaasPeerInstanceRootAccount = (account) =>
  Boolean(
    account
    && (account.isInstanceRoot === true || account.is_instance_root === true),
  );

/**
 * True when opening this account from matrix should pin the peer tenant for backoffice.
 */
export const shouldPinPeerForAccountOps = (account, selectedInstance) => {
  if (!account || !selectedInstance) return false;
  if (!isValutSegregationWalletInstance(selectedInstance)) return false;
  const peerId = Number(account.instanceId ?? account.baasInstanceId);
  const matrixId = Number(
    selectedInstance.baasInstanceId ?? selectedInstance.instanceId,
  );
  if (!Number.isFinite(peerId) || peerId <= 0) return false;
  if (Number.isFinite(matrixId) && peerId === matrixId) return false;
  return (
    isBaasPeerInstanceRootAccount(account)
    || account.isPeerInstanceAccount === true
    || account.is_peer_instance_account === true
  );
};

/**
 * True when opening this entity from matrix should pin the peer tenant.
 */
export const shouldPinPeerForEntityOps = (entity, selectedInstance) => {
  if (!entity || !selectedInstance) return false;
  if (!isValutSegregationWalletInstance(selectedInstance)) return false;
  if (entity.isPeerInstanceOwner !== true && !entity.instanceId) return false;
  const peerId = Number(entity.instanceId ?? entity.baasInstanceId);
  const matrixId = Number(
    selectedInstance.baasInstanceId ?? selectedInstance.instanceId,
  );
  if (!Number.isFinite(peerId) || peerId <= 0) return false;
  return !Number.isFinite(matrixId) || peerId !== matrixId;
};
